


































































import { defineComponent } from "@vue/composition-api";
import { BlockingStatus } from "@scrile/api-provider/dist/api/BlockingStatusProvider";
import { MessageThread } from "@scrile/api-provider/dist/api/MessageThreadsProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { BaseMenuItem } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/BaseInput";
import BaseMenu from "@/components/BaseMenu";
import BasePage from "@/components/BasePage";
import BaseSpinner from "@/components/BaseSpinner";
import EmptyContent from "@/components/EmptyContent";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import MessageThreadItem from "./MessageThreadItem.vue";
import MessageThreadsSort from "./MessageThreadsSort.vue";

export default defineComponent({
  name: "MessageThreadsView",
  components: {
    BaseSpinner,
    BaseInput,
    EmptyContent,
    InfiniteScroll,
    BasePage,
    BaseMenu,
    PageTitle,
    MessageThreadItem,
    BaseIcon,
    MessageThreadsSort,
  },
  props: {
    loading: { type: Boolean, required: true },
    allowMassMessage: { type: Boolean, required: true },
    messageThreadList: { type: Array as () => MessageThread[], required: true },
    authUserId: { type: String, required: true },
    scroll: { type: Boolean, required: true },
    blockingStatus: { type: Array as () => BlockingStatus[], required: true },
    currentSortItem: { type: Number, required: true },
    term: { type: String, required: true },
    filterLoading: { type: Boolean, required: true },
  },
  setup() {
    const { authorities, isMember } = useAuthUser();
    return {
      authorities,
      isMember,
    };
  },
  computed: {
    emptyThreads(): boolean {
      return !this.loading && this.messageThreadList.length === 0;
    },
    blockStatusList(): Record<string, boolean> {
      const list: Record<string, boolean> = {};
      this.blockingStatus.forEach(s => (list[s.blockedUserId] = true));
      return list;
    },
    allowMassMessageStat(): boolean {
      return checkAuthorities(this.authorities, ["updateMyContentPrice", "getMyMassMessageStat"]);
    },
    allowScheduledMassMessage(): boolean {
      return config.featureScheduledMassMessage && this.allowMassMessage;
    },
    allowSortThreads(): boolean {
      return config.featureSortMessages && !this.isMember;
    },
    menuItems(): BaseMenuItem[] {
      const items = [];
      if (this.allowMassMessage) {
        items.push({
          name: "sendMassMessage",
          text: $t("Send Mass message"),
          prependIcon: "sci-send",
        });
      }
      if (this.allowScheduledMassMessage) {
        items.push({
          name: "scheduledMassMessage",
          text: $t("Scheduled mass messages"),
          prependIcon: "sci-calendar-outline",
        });
      }
      if (this.allowMassMessageStat) {
        items.push({
          name: "statistics",
          text: $t("Statistics"),
          prependIcon: "sci-bar",
        });
      }
      return items;
    },
  },
  methods: {
    getBlockStatus(ids: string[]): boolean {
      const opponentId = ids[0] === this.authUserId ? ids[1] : ids[0];
      return this.blockStatusList[opponentId] ?? false;
    },
    clearSearchInput() {
      if (this.term.length > 0) {
        this.$emit("clearFilter");
      }
    },
  },
});
